module.exports = __webpack_public_path__ + "static/media/product-detail-small-placeholder.08a075ab.webp";